import angular from 'angular';
import { ui } from 'angular';
import { IMovimentacaoAdmissaoFormModalParams } from '../../models/movimentacoes-admissoes.model';

export class MovimentacoesAdmissoesFormModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: angular.ui.bootstrap.IModalService) { }

    public open(params: IMovimentacaoAdmissaoFormModalParams): ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('!!html-loader!./movimentacoes-admissoes-form.modal.html'),
            controller: 'MovimentacoesAdmissoesFormModalController',
            controllerAs: 'mvmntcsAdmssFrmMdlCntrllr',
            windowClass: 'nsj-modal-lg-no-height',
            backdrop: 'static',
            resolve: {
                params: () => params
            }
        });
    }
}
